import {FC} from 'react'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {UserModel} from '../../../../app/shared/models'
import * as auth from '../../../../app/pages/auth/redux/AuthRedux'
import {RootState} from '../../../../setup'

const HeaderSelectPdv: FC = () => {
    const user: UserModel = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const dispatch = useDispatch()

    async function handleSelectPdv(pdvId: number) {
        dispatch(auth.actions.setPdv(pdvId))

        document.location.reload()
    }

    return (
        <div
            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
            data-kt-menu='true'
        >
            <ul className='list-group px-2'>
                {user?.user_pdvs.map(
                    (userPdv) =>
                        userPdv.pdv.fl_approved &&
                        userPdv.pdv.status && (
                            <li key={userPdv.pdv.id} className='list-group-item border-0 menu-item'>
                                <button
                                    className='btn btn-sm btn-active-primary w-100 text-start'
                                    onClick={() => handleSelectPdv(userPdv.pdv.id)}
                                >
                                    {userPdv.pdv.nm_fantasy}
                                </button>
                            </li>
                        )
                )}
            </ul>
        </div>
    )
}

export {HeaderSelectPdv}
